function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7143 0H2.57143C1.15313 0 0 1.15313 0 2.57143V33.4286C0 34.8469 1.15313 36 2.57143 36H25.7143C27.1326 36 28.2857 34.8469 28.2857 33.4286V2.57143C28.2857 1.15313 27.1326 0 25.7143 0ZM25.3929 33.1071H2.89286V2.89286H25.3929V33.1071ZM12.5357 28.9286C12.5357 29.3548 12.705 29.7636 13.0064 30.065C13.3078 30.3664 13.7166 30.5357 14.1429 30.5357C14.5691 30.5357 14.9779 30.3664 15.2793 30.065C15.5807 29.7636 15.75 29.3548 15.75 28.9286C15.75 28.5023 15.5807 28.0935 15.2793 27.7921C14.9779 27.4908 14.5691 27.3214 14.1429 27.3214C13.7166 27.3214 13.3078 27.4908 13.0064 27.7921C12.705 28.0935 12.5357 28.5023 12.5357 28.9286Z",
  fill: "currentColor"
});

var SvgIcTablet = function SvgIcTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tablet.b3b34a5a.svg";
export { ForwardRef as ReactComponent };